import { useNavigate } from "react-router";
import { useApiResource } from "@/hooks/useApiResource";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api, type Usuario, type VerComoOpcion } from "@/lib/api";

/** Franja de "Ver como fiduciante": elegir a quién ver (sin salir de la vista) y Salir, que vuelve a ser el admin (sin JSX). */
export function useFranjaVerComo(fid: number, onRecargarUsuario: () => Promise<void>) {
  const navigate = useNavigate();
  const ruta = `/api/fideicomisos/${fid}/ver-como`;
  const opciones = useApiResource<VerComoOpcion[]>(ruta);
  const accionSalir = useAsyncAction(() => api.delete<Usuario>("/api/auth/ver-como"));
  const accionCambiar = useAsyncAction((id: number) => api.put<void>(ruta, { fiduciante_id: id }).then(() => true));

  const salir = async () => {
    if (!(await accionSalir.run())) return;
    await onRecargarUsuario();
    navigate("/fiduciantes");
  };
  const cambiar = async (valor: string) => {
    if (!(await accionCambiar.run(Number(valor)))) return;
    await onRecargarUsuario();
  };

  return {
    opciones: (opciones.data ?? []).map((o) => ({ valor: String(o.fiduciante_id), etiqueta: o.nombre })),
    cambiar,
    cambiando: accionCambiar.loading,
    salir,
    saliendo: accionSalir.loading,
    error: accionSalir.error ?? accionCambiar.error,
  };
}
